<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6 title-position">
      <span class="title" id="titleDetails">{{ 'TRANSLATE.ELEGIBILITY.DETAILS' | translate }}</span>
      <span class="title" id="titleEdit">{{ 'TRANSLATE.EDIT.ELEGIBILITY' | translate }}</span>
      <span class="sub-title" id="subTitle">
        {{ 'TRANSLATE.REVIEW.UPDATE.ELEGIBILITY.INFORMATION' | translate }}
      </span>
    </div>
  </div>

  <div class="container-body">
    <div class="col-11 md:col-11 lg:col-11 editing-items">

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-6 lg:col-6 element-option-select space">
          <label class="element-option-select-filter" for="productIdName">{{ 'TRANSLATE.ID.PRODUCT.NAME' |
            translate }}
          </label>
          <p-autoComplete [disabled]="selectDisabled" placeholder="{{ placeholderProduct | translate }}"
            [suggestions]="productArray" [(ngModel)]="selectedProducts" id="productIdName" optionLabel="label"
            (completeMethod)="searchProducts($event)" (onSelect)="productChange($event)" field="label" [dropdown]="true"
            autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>
          @if (isEditingMode && hasAttemptedSave && !selectedProducts) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.PRODUCT' | translate }}">
          </p-message>
          }
        </div>

        <div class="col-12 md:col-6 lg:col-6 element-option-select space">
          <label class="element-option-select-filter" for="coverageName">{{ 'TRANSLATE.COVERAGE' | translate
            }} </label>
          <p-autoComplete placeholder="{{ placeholderCoverage | translate }}" [disabled]="selectDisabled"
            [suggestions]="coveragesConcat" [(ngModel)]="selectedCoverages" id="coverageName" optionLabel="label"
            (completeMethod)="searchCoverages($event)" (onSelect)="coverageChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>
          @if (isEditingMode && hasAttemptedSave && !selectedCoverages) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.COVERAGE' | translate }}">
          </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-6 lg:col-4 element-edit">
          <label class="element-edit-label" for="elegibilidadeCountry">{{ 'TRANSLATE.COUNTRY' | translate }}
          </label>
          <input class="element-edit-input disabled-input" id="elegibilidadeCountry" [(ngModel)]="countryNameResult"
            type="text" maxlength="3" disabled pInputText>
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-option-select orange-text-box">
          <label class="element-option-select-filter" for="salesChannel">{{ 'TRANSLATE.SALES.CHANNEL' |
            translate }} </label>
          <p-dropdown [options]="listSalesChannel" [(ngModel)]="selectedSalesChannel" id="salesChannel"
            placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [disabled]="selectDisabled"
            (onChange)="canalVendasChange($event)" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              {{item?.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item?.label | translate}}
            </ng-template>
          </p-dropdown>

          @if (isEditingMode && hasAttemptedSave && !selectedSalesChannel) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.SELECT.SALES.CHANNEL' | translate }}">
          </p-message>
          }
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-option-select orange-text-box space-two">
          <label class="element-option-select-filter" for="status">{{ 'TRANSLATE.STATUS' | translate }}
          </label>

          <p-dropdown [options]="listStatus" id="status" [disabled]="selectDisabled"
            placeholder="{{ 'TRANSLATE.SELECT' | translate }}" (onChange)="statusChange($event)"
            [style]="{'minWidth':'100%'}" [(ngModel)]="selectedStatus">
            <ng-template pTemplate="item" let-item>
              {{item?.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item?.label | translate}}
            </ng-template>
          </p-dropdown>

          @if (isEditingMode && hasAttemptedSave && (selectedStatus === null || selectedStatus === undefined)) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.STATUS' | translate }}">
          </p-message>
          }
        </div>

      </div>

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-12 lg:col-4 element-option-select orange-text-box space-two">
          <label class="element-option-select-filter" for="yearVehicle">{{ 'TRANSLATE.YEAR.VEHICLE' |
            translate }}</label>
          <p-dropdown [placeholder]="placeholderField | translate" [options]="listYearVehicle"
            [(ngModel)]="selectedYear" id="yearVehicle" [disabled]="selectDisabled"
            (onChange)="yearVehicleChange($event)" [style]="{'minWidth':'100%'}">
            <ng-template pTemplate="item" let-item>
              {{item?.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item?.label | translate}}
            </ng-template>
          </p-dropdown>
          @if (isEditingMode && hasAttemptedSave && !selectedYear) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.SELECT.YEAR.VEHICLE' | translate }}">
          </p-message>
          }
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-option-select orange-text-box">
          <label class="element-option-select-filter" for="vehicle">{{ 'TRANSLATE.VEHICLE' | translate }}
          </label>
          <p-autoComplete placeholder="{{ placeholderVehicle | translate }}" [suggestions]="vehicleLineConcat"
            [(ngModel)]="selectedVehicleLine" id="vehicle" optionLabel="label" [disabled]="selectDisabled"
            (completeMethod)="searchVehicleLines($event)" (onSelect)="vehicleLineChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>
          @if (isEditingMode && hasAttemptedSave && !selectedVehicleLine) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.VEHICLE' | translate }}">
          </p-message>
          }
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-edit space-two orange-text-box">
          <label class="element-edit-label" for="monthsOffer">{{ 'TRANSLATE.MONTHS.OFFER' | translate
            }}</label>
          <input class="element-edit-input disabled-input" id="monthsOffer" [(ngModel)]="productPolicy.months"
            type="text" min="1" max="999" maxlength="3" (input)="monthsOffer($event)" disabled pInputText>
          @if (isEditingMode && hasAttemptedSave && (inputMonthsOffer === null || inputMonthsOffer === undefined)) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
          </p-message>
          }
        </div>

      </div>

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-12 lg:col-4 element-option-select space-two orange-text-box">
          <label class="element-option-select-filter" for="warrantyCost">{{ 'TRANSLATE.WARRANTY.COST' |
            translate }} </label>
          <p-autoComplete placeholder="{{ placeholderWarranty | translate }}" [suggestions]="warrantyCosts"
            [(ngModel)]="selectedWarrantyCost" id="warrantyCost" optionLabel="label"
            (completeMethod)="searchWarrantyCosts($event)" (onSelect)="warrantyCostChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>

        </div>

        <div class="col-12 md:col-6 lg:col-4 element-option-select orange-text-box">
          <label class="element-option-select-filter" for="serviceCost">{{ 'TRANSLATE.SERVICE.COST' |
            translate }} </label>
          <p-autoComplete placeholder="{{ placeholderServiceCost | translate }}" [suggestions]="serviceCosts"
            [(ngModel)]="selectedServiceCost" id="serviceCost" optionLabel="label"
            (completeMethod)="searchServiceCosts($event)" (onSelect)="serviceCostChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>

        </div>

        <div class="col-12 md:col-6 lg:col-4 element-option-select space-two orange-text-box">
          <label class="element-option-select-filter" for="fordCost">{{ 'TRANSLATE.FORDCOST.PRICE' | translate
            }} </label>
          <p-autoComplete placeholder="{{ placeholderFordCost | translate }}" [suggestions]="fordCosts"
            [(ngModel)]="selectedFordCostPrice" id="fordCost" optionLabel="label"
            (completeMethod)="searchFordCosts($event)" (onSelect)="fordCostChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>

        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-12 lg:col-4 element-option-select space-two orange-text-box">
          <label class="element-option-select-filter" for="sellerPrice">{{ 'TRANSLATE.SELLER.PRICE' |
            translate }} </label>
          <p-autoComplete placeholder="{{ placeholderSeller | translate }}" [suggestions]="sellerPrices"
            [(ngModel)]="selectedSellerPrice" optionLabel="label" id="sellerPrice"
            (completeMethod)="searchSellerPrices($event)" (onSelect)="sellerPriceChange($event)" field="label"
            [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>
          @if (showSellerPriceError) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.SELECT.SELLER.PRICE' | translate }}">
          </p-message>
          }
        </div>

        <div class="col-12 md:col-12 lg:col-4 element-option-select orange-text-box top-space">
          <label class="element-option-select-filter" for="customerPrice">{{ 'TRANSLATE.SELECT.PRICE.CUSTOMER'
            | translate }}
          </label>
          <p-autoComplete [disabled]="selectDisabled" placeholder="{{ placeholderCustomerPrice | translate }}"
            [suggestions]="customersPricesConcat" [(ngModel)]="selectedCustomerPrice" optionLabel="label"
            id="customerPrice" (completeMethod)="searchCustomerPrices($event)" (onSelect)="customerPriceChange($event)"
            field="label" [dropdown]="true" autoHighlight [emptyMessage]="'TRANSLATE.NO.RESULT.FOUND' | translate"
            [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              <span>{{ item.label }}</span>
            </ng-template>
          </p-autoComplete>

          @if (showCustomerPriceError) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.SELECT.CUSTOMER.PRICE' | translate }}">
          </p-message>
          }
        </div>

      </div>

      <div class="col-12 md:col-12 lg:col-12 element-text-select">

        <div class="col-12 md:col-12 lg:col-12 element-option-select description-width">
          <label class="element-option-select-filter" for="policyDescription">{{
            'TRANSLATE.DESCRIPTION.ELIGIBILITY' | translate }}
          </label>
          <textarea class="element-edit-input disabled-input large-text" id="policyDescription"
            [(ngModel)]="productPolicy.policyDescription" maxlength="50" disabled pInputTextarea></textarea>

          <div class="char-counter">
            {{ productPolicy.policyDescription?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.50' | translate
            }}
          </div>
        </div>

      </div>

    </div>

    <div class="button-position">

      @if (!isEditingMode) {
      <button id="btnReturn" class="undo-action-button app-clean-button" type="button" (click)="buttonReturn()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>
      }

      @if (!isEditingMode) {
      <button id="btnEdit" class="action-button app-filter-button" type="button" (click)="buttonEdit()">
        <i class="pi pi-pencil" aria-hidden="true"></i>
        <span class="action-button-label">{{ 'TRANSLATE.EDIT' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnCancel" class="undo-action-button app-clean-button" type="button" (click)="buttonCancel()"
        [disabled]="blockedUi">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.CANCEL' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnSave" class="action-button app-filter-button" type="submit" (click)="buttonSave()"
        [disabled]="blockedUi">
        @if (!blockedUi) {
        <i class="pi pi-check" aria-hidden="true"></i>
        }
        @if (blockedUi) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="action-button-label">{{ (blockedUi ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}</span>
      </button>
      }

    </div>
  </div>
</div>